import Box from "@mui/material/Box";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { People } from "@mui/icons-material";
import { Grid } from "@mui/material";
import EnrollmentChart from "./components/EnrollmentChart";
import RecentActivities from "./components/RecentlyActivity";
import StatsCard from "./components/StatsCard";

const statsData = [
  {
    title: "Total Students",
    value: "1,245",
    icon: <People />,
    bgColor: "#dbeafe",
    iconColor: "#3b82f6",
  },
  {
    title: "Total Courses",
    value: "18",
    icon: <MenuBookIcon />,
    bgColor: "#ede9fe",
    iconColor: "#7c3aed",
  },

  {
    title: "Pending Reviews",
    value: "6",
    icon: <PendingActionsIcon />,
    bgColor: "#fed7aa",
    iconColor: "#f59e0b",
  },
  {
    title: "Active Assessments",
    value: "10",
    icon: <AssignmentTurnedInIcon />,
    bgColor: "#fce7f3",
    iconColor: "#ec4899",
  },
];

export default function DashboardOverview() {
  return (
    <Box>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {statsData.map((stat) => (
          <Grid key={stat.title} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <StatsCard
              title={stat.title}
              value={stat.value}
              icon={stat.icon}
              bgColor={stat.bgColor}
              iconColor={stat.iconColor}
            />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <EnrollmentChart />
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <RecentActivities />
        </Grid>
      </Grid>
    </Box>
  );
}
